import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { GlobalComponent } from "../../global-component";
import { TokenStorageService } from './token-storage.service';
import { User } from '../models/user.models';

const BASE_URL = GlobalComponent.BASE_API_URL;
const SERVICE_CHARGES_API = BASE_URL + GlobalComponent.vendorservicecharges;

@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class ServiceChargesService {

    currentUser!: User;
    constructor(private http: HttpClient, private tokenService: TokenStorageService) {
        this.currentUser = this.tokenService.getUser();
    }

    /**
    * VENDOR SERVICE CHARGES API
    */
    vendorservicecharges(servicechargesobj: any) : Observable<any> {
        console.log("checking service charges");
        let postdata = {
            "data": {
                charges: servicechargesobj,
                vendorguid: this.tokenService.getVendorGUID(),
                activestate: true
            }
        }
        return this.http.post<any>(SERVICE_CHARGES_API, postdata);
    }

     /**
    * GET CLIENT SERVICE CHARGES API
    */
     getclientservicecharges(clientguid: string) : Observable<any[]> {
        console.log("checking service charges", clientguid);
        // let userData = this.tokenService.getUser();
        return this.http.get<any[]>(BASE_URL + 'servicecharges?filters[activestate][$eq]=true&filters[clientguid]='+clientguid);
    }

    /**
    * GET VENDOR SERVICE CHARGES API
    */
    getvendorservicecharges() : Observable<any[]> {
        console.log("checking service charges");
        return this.http.get<any[]>(BASE_URL + 'vendorservicecharges?filters[activestate][$eq]=true&filters[vendorguid]='+this.tokenService.getVendorGUID());
    }
    
    /**
     * CREATE CLIENT SERVICE CHARGES
     */
     addclientservicecharges(servicechargesobj: any, clientguid: string) : Observable<any> {
        console.log("client service charges");
        let postdata = {
            "data": {
                charges: servicechargesobj,
                vendorguid: this.tokenService.getVendorGUID(),
                activestate: true,
                performerguid: this.currentUser.guid,
                clientguid: clientguid
            }
        }
        return this.http.post<any>(BASE_URL + 'servicecharges', postdata);
    }

    /**
     * UPDATE CLIENT SERVICE CHARGES
     */
    editclientservicecharges(servicechargesobj: any, servicechargesid: number) : Observable<any> {
        console.log("edit client service charges");
        let postdata = {
            "data": {
                charges: servicechargesobj
            }
        }
        return this.http.put<any>(BASE_URL + 'servicecharges/' + servicechargesid, postdata);
    }

    /**
    * STAMPING PARTNER SERVICE CHARGES API
    */
    stampingpartnerservicecharges(servicechargesobj: any, stampingpartnerguid: string) : Observable<any> {
        console.log("stamping service charges");
        let postdata = {
            "data": {
                charges: servicechargesobj,
                vendorguid: this.tokenService.getVendorGUID(),
                activestate: true,
                stampingpartnerguid: stampingpartnerguid
            }
        }
        return this.http.post<any>(BASE_URL + 'stampingpartnerservicecharges', postdata);
    }

    /**
     * UPDATE STAMPING PARTNER SERVICE CHARGES
     */
    editstampingpartnerservicecharges(servicechargesobj: any, servicechargesid: number) : Observable<any> {
        console.log("edit stamping partner service charges");
        let postdata = {
            "data": {
                charges: servicechargesobj
            }
        }
        return this.http.put<any>(BASE_URL + 'stampingpartnerservicecharges/' + servicechargesid, postdata);
    }

    /**
    * GET STAMPING PARTNER SERVICE CHARGES API
    */
    getstampingpartnerservicecharges(stampingpartnerguid: string) : Observable<any[]> {
        console.log("checking service charges", stampingpartnerguid);
        return this.http.get<any[]>(BASE_URL + 'stampingpartnerservicecharges?filters[activestate][$eq]=true&filters[stampingpartnerguid]='+stampingpartnerguid+'&filters[vendorguid]='+this.tokenService.getVendorGUID());
    }
}